import { Grid } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowContainerFullStore } from "../../../../../store";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const SellosSalidaVerificadora = () => {
  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white", pt:2 }}
    >
      <EtiquetaPuerta /> 
      <SelloCable />
      <SelloRastreo />
      <NumeroRastreo />
    </Grid>
  );
};

//SELLOS SALIDA VERIFICADORA

const EtiquetaPuerta = () => {
  const {
    open: openAdhesivo,
    handleClose: handleCloseAdhesivo,
    handleOpen: handleOpenAdhesivo,
  } = useOpen();

  const adhesivoPhoto = useWorkflowContainerFullStore(
    (state) => state.adhesivoPhoto
  );

  const setAdhesivoPhoto = useWorkflowContainerFullStore(
    (state) => state.setAdhesivoPhoto
  );
  const fotoUrl = useBlobUrl(adhesivoPhoto);


  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseAdhesivo}
        handleOpen={handleOpenAdhesivo}
        label="ETIQUETA PUERTA"
        open={openAdhesivo}
        setFoto={setAdhesivoPhoto}
        fontSize={12}
        width={220}
      />
    </Grid>
  );
};

const SelloCable = () => {
  const {
    open: openCableVerificadora,
    handleClose: handleCloseCableVerificadora,
    handleOpen: handleOpenCableVerificadora,
  } = useOpen();

  const cableVerificadoraPhoto = useWorkflowContainerFullStore(
    (state) => state.cableVerificadoraPhoto
  );

  const setCableVerificadoraPhoto = useWorkflowContainerFullStore(
    (state) => state.setCableVerificadoraPhoto
  );
  const fotoUrl = useBlobUrl(cableVerificadoraPhoto);


  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCableVerificadora}
        handleOpen={handleOpenCableVerificadora}
        label="SELLO CABLE"
        open={openCableVerificadora}
        setFoto={setCableVerificadoraPhoto}
        fontSize={12}
        width={220}
      />
    </Grid>
  );
};

const SelloRastreo = () => {
  const {
    open: openBotellaVerificadoraRastreo,
    handleClose: handleCloseBotellaVerificadoraRastreo,
    handleOpen: handleOpenBotellaVerificadoraRastreo,
  } = useOpen();

  const botellaVerificadoraRastreoPhoto = useWorkflowContainerFullStore(
    (state) => state.botellaVerificadoraRastreoPhoto
  );

  const setBotellaVerificadoraRastreoPhoto = useWorkflowContainerFullStore(
    (state) => state.setBotellaVerificadoraRastreoPhoto
  );
  const fotoUrl = useBlobUrl(botellaVerificadoraRastreoPhoto);


  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseBotellaVerificadoraRastreo}
        handleOpen={handleOpenBotellaVerificadoraRastreo}
        label="SELLO RASTREO"
        open={openBotellaVerificadoraRastreo}
        setFoto={setBotellaVerificadoraRastreoPhoto}
        fontSize={12}
        width={220}
      />
    </Grid>
  );
};

const NumeroRastreo = () => {
  const {
    open: openNumRastreoSatelital,
    handleClose: handleCloseNumRastreoSatelital,
    handleOpen: handleOpenNumRastreoSatelital,
  } = useOpen();

  const numRastreoSatelitalPhoto = useWorkflowContainerFullStore(
    (state) => state.numRastreoSatelitalPhoto
  );

  const setNumRastreoSatelitalPhoto = useWorkflowContainerFullStore(
    (state) => state.setNumRastreoSatelitalPhoto
  );
  const fotoUrl = useBlobUrl(numRastreoSatelitalPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseNumRastreoSatelital}
        handleOpen={handleOpenNumRastreoSatelital}
        label="N° RASTREO"
        open={openNumRastreoSatelital}
        setFoto={setNumRastreoSatelitalPhoto}
        fontSize={12}
        width={220}
      />
    </Grid>
  );
};
